<ng-container *ngIf="externalButton">
    <div>
        <ion-button *ngIf="externalButton.type == 'external_link'"
                    color="danger"
                    (click)="openLink()">
            {{externalButton.button_label}}
        </ion-button>

        <ion-button *ngIf="externalButton.type == 'info'"
                    color="danger"
                    (click)="showInfo()">
            {{externalButton.button_label}}
        </ion-button>
    </div>
</ng-container>